export default {"src":"/_next/static/media/banzai_logo_rgb_black.c947993a.svg","height":96,"width":402,"blurWidth":0,"blurHeight":0};